import * as React from 'react';
const AnimatePresenceContext = /*#__PURE__*/ React.createContext({
    emptyRender: undefined
});
export function AnimatePresenceProvider({ emptyRender, children }) {
    return /*#__PURE__*/ React.createElement(AnimatePresenceContext.Provider, {
        value: {
            emptyRender
        }
    }, children);
}
export function useAnimatePresenceContext() {
    return React.useContext(AnimatePresenceContext);
}

//# sourceMappingURL=context.js.map